import { useEffect } from 'react';
import Lenis from 'lenis';

/** Site-wide inertial wheel scrolling. Native touch scrolling and reduced-motion are left untouched. */
export default function useSmoothScroll() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const root = document.documentElement;
    root.classList.add('lenis-on');
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 1 });

    let raf = 0;
    const loop = (t: number) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const headerOffset = () => parseFloat(getComputedStyle(root).getPropertyValue('--header-h')) || 64;

    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const a = (e.target as HTMLElement).closest('a[href^="#"]') as HTMLAnchorElement | null;
      if (!a) return;
      const hash = a.getAttribute('href') || '';
      const target = hash === '#' || hash === '#top' ? null : document.querySelector(hash);
      if (hash !== '#' && hash !== '#top' && !target) return;
      e.preventDefault();
      if (target) lenis.scrollTo(target as HTMLElement, { offset: -headerOffset() });
      else lenis.scrollTo(0);
      if (window.location.hash !== hash) window.history.pushState(null, '', hash);
    };
    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
      root.classList.remove('lenis-on');
    };
  }, []);
}